import { render, staticRenderFns } from "./question-content.vue?vue&type=template&id=0374e20e&"
import script from "./question-content.vue?vue&type=script&lang=js&"
export * from "./question-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports